<template>
	<div class="am-map-image">
	</div>
</template>

<script>
import { Map, Marker, Icon, ImageOverlay, LatLngBounds, LatLng, CRS } from 'leaflet'
import LabeledMarker from 'leaflet-labeled-circle'

export default {
	props: {
		image: {
			type: String,
			default: 'https://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg'
		},
		minZoom: {
			type: Number,
			default: 2
		},
		maxZoom: {
			type: Number,
			default: 3
		},
		zoom: {
			type: Number,
			default: 2
		},
		markers: {
			type: Array,
			default: () => ([
				{ id: 1, lat: -53.75, lng: 73.5, name: 'Lorem ipsum sit amet' },
				{ id: 2, lat: -42, lng: 42.75, name: 'Condominio das Americas' }
			])
		}
	},

	data: () => ({
		map: null
	}),

	mounted() {
		setTimeout(() => {
			this.init()
		}, 500)
	},

	destroyed() {
		setTimeout(() => this.map.remove(), 200)
	},

	methods: {
		init() {
			let vm = this,
				image = new Image()

			// Initialize map
			this.map = new Map(this.$el, {
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				center: [0, 0],
				zoom: this.zoom,
				crs: CRS.Simple,
				attributionControl: false,
				scrollWheelZoom: false
			})

			// Set image source
			image.src = this.image

			// Load image
			image.onload = function() {
				let w = this.width / 2,
					h = this.height / 2,
					southWest = vm.map.unproject([0, h], this.maxZoom - 1),
					northEast = vm.map.unproject([w, 0], this.maxZoom - 1),
					bounds = new LatLngBounds(
						southWest,
						northEast
					)

				// Center map
				vm.map.fitBounds(bounds)

				// Add image to map
				vm.map.addLayer(new ImageOverlay(
					this.src, bounds, {
						opacity: 1,
						interactive: true,
					}
				))
			}

			let icon = new Icon({
				iconUrl: '/images/marker.svg',
				iconSize: [46, 55],
				iconAnchor: [23, 55],
				popupAnchor: [0, -70],
			})

			// Add markers to map
			this.markers.forEach(item => {
				let marker = new LabeledMarker([item.lat, item.lng], {
					draggable: true,
					type: "Feature",
					properties: { "text": item.id },
				}, {
					markerOptions: {
						stroke: false,
						radius: 10,
						fillOpacity: 1,
						color: '#FF89CD',
						textStyle: {
							fontSize: '9px',
							fontWeight: '200',
							color: 'white'
						}
					}
				})

				// Marker click event
				marker.on('click', () => {
					this.$emit('click', item)
				})

				// Add tooltip
				marker.bindTooltip(item.name)

				// Add to map
				marker.addTo(this.map)
			})

			this.map.on('click', event => {
				let coord = event.latlng

				console.log({
					lat: coord.lat,
					lng: coord.lng
				})
			})

		}
	}
}
</script>

<style lang="scss">
.am-map-image{
	min-height: 200px;
	height: 100%;
	background: white !important;
}
</style>
